import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Abc from '../DashboardScreens/Abc'
import NavCrum from '../DashboardScreens/Nav'
import { Box } from '@mui/material'
import Upload from '../DashboardScreens/Upload'
import ChatInterface from '../DashboardScreens/ChatInterface'

const AppRouter = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Abc />} />
          
          <Route path='upload' element={<Upload />} />
          <Route path='chat' element={<ChatInterface />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default AppRouter
